<template>
    <b-row class="program" align-h="start">
        <!--<transition name="slide-fade"> -->
            <b-col v-if="show" cols="12" lg="6" class="program-content-image overflow-hidden">
                <!-- <img class="program-imagen" :src="srcImagen"> -->
            </b-col>
        <!-- </transition> -->
        <!-- <transition name="slide-fade2"> -->
            <b-col v-if="show" cols="12" class="program-content-titulo" lg="6">
                <b-row>
                    <b-col cols="11" class=" mx-auto">
                        <p   p class="program-titulo"  v-html="content.titulo"></p>
                        <p class="program-content" v-html="content.content"></p>
                    </b-col>
                </b-row>
            </b-col>
        <!-- </transition>-->
        
    </b-row>
</template>
<script>
    export default {
        name: 'section-program',
        components: {},
        props: {
            content: Object
        },
        created: function () {
            var self = this;
            setTimeout(() => {
                self.show = true
            }, 10);
        },
        computed: {
            srcImagen() {
                let src = require('@/assets/images/commerce_internal/' + this.content.imagen)
                return src
            }
        },
        data: () => ({
            show: false,
        }),
        methods: {

        }
    }
</script>
<style scoped>
    .slide-fade-enter-active {
        transition: all 1.3s ease-in-out;
    }
    .slide-fade-leave-active {
        /*transition: all 1.8s cubic-bezier(1.0, 0.5, 0.8, 1.0);*/
    }
    .slide-fade-enter {
        transition: all 1.5s ease;
        transform: translate(-1650px,0);
        -webkit-transform: translate(-1650px,0); /** Safari & Chrome **/
        -o-transform: translate(-1650px,0); /** Opera **/
        -moz-transform: translate(-1650px,0); /** Firefox **/
    }

    .slide-fade2-enter-active {
        transition: all 1.3s ease-in-out;
    }
    .slide-fade2-leave-active {
        /*transition: all 1.8s cubic-bezier(1.0, 0.5, 0.8, 1.0);*/
    }
    .slide-fade2-enter, .slide2-fade-leave-to {
        transition: all 1.5s ease;
        transform: translate(1650px,0);
        -webkit-transform: translate(1650px,0); /** Safari & Chrome **/
        -o-transform: translate(1650px,0); /** Opera **/
        -moz-transform: translate(1650px,0); /** Firefox **/
    }

    @media (max-width: 600px) {
        .program-titulo{
            margin: 0px;
            font-size:  30px;
        }
        .program-content{
            margin: 0px;
            font-size: 20px;
        }
    }

</style>